import React from 'react'
import { Card, BodyText, PAYPAL_THEME, Col } from '@paypalcorp/pp-react'

const NotificationCard = ({ icons, title, bodyText, handlerClick }) => {
  const { sysColorBackgroundMediumContrast } = PAYPAL_THEME

  return (
    <Col md={3} style={{ marginTop: '24px' }}>
      <Card className="w-100">
        <div className="notification-card-wrapper">
          <div>{icons}</div>
        </div>
        <Card.Content>
          <div className="mb-5p">
            <BodyText strong className="noti-bodyTitle" onClick={handlerClick}>
              {title}
            </BodyText>
          </div>
          <BodyText style={{ color: sysColorBackgroundMediumContrast }}>
            {bodyText}
          </BodyText>
        </Card.Content>
      </Card>
    </Col>
  )
}

export default NotificationCard
